import { createFileRoute } from "@tanstack/react-router";
import AcceleratedTmsPage from "@/pages/learn/AcceleratedTmsPage";
import { page3 } from "@/pages/learn/learnDataP3";
export const Route = createFileRoute(
  "/learn/accelerated-tms-theta-burst-stimulation",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Accelerated TMS & Theta Burst (iTBS): What to Know",
        },
        {
          name: "description",
          content:
            "Accelerated TMS and theta burst (iTBS) explained: 3-minute sessions, multi-session days, the THREE-D trial, FDA-cleared vs off-label protocols, and cost.",
        },
        {
          property: "og:title",
          content: "Accelerated TMS & Theta Burst (iTBS): What to Know",
        },
        {
          property: "og:description",
          content:
            "Accelerated TMS and theta burst (iTBS) explained: 3-minute sessions, multi-session days, the THREE-D trial, FDA-cleared vs off-label protocols, and cost.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/learn/accelerated-tms-theta-burst-stimulation",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/learn/accelerated-tms-theta-burst-stimulation",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(page3.schemaJson),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AcceleratedTmsPage />;
}
